import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormArray, FormControl } from '@ngneat/reactive-forms';
import { deepEqual } from 'fast-equals';
import {
  distinctUntilChanged,
  filter,
  map,
  merge,
  skip,
  startWith,
} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ValidationService {
  validateControl(
    control: AbstractControl,
    directValidation,
    delayedValidation,
  ) {
    let directValidationFail = false;
    let delayedValidationFail = false;
    if (control.errors) {
      for (const error of directValidation) {
        if (control.errors[error]) {
          directValidationFail = true;
          break;
        }
      }

      for (const error of delayedValidation) {
        if (control.errors[error]) {
          delayedValidationFail = true;
          break;
        }
      }
    }
    return (
      control.invalid &&
      ((directValidationFail && (control.dirty || control.touched)) ||
        (delayedValidationFail && control.touched))
    );
  }

  isInvalid(control: FormControl<unknown> | FormArray<unknown>) {
    return merge(
      control.errors$.pipe(
        distinctUntilChanged((prev, curr) => deepEqual(prev, curr)),
        skip(1),
      ),
      control.touch$.pipe(
        startWith(control.touched),
        filter((touched) => touched),
      ),
      control.dirty$.pipe(filter((dirty) => dirty)),
    ).pipe(
      map(() => {
        return control.invalid && control.dirty && control.touched;
      }),
    );
  }
}
